
import { useEffect, useMemo, useState } from 'react';
import { useGetUserNotificationsQuery } from '../api';
import { NotificationDetail, UserContext } from '../types';

interface UseNotificationsArgs {
    userId?: string;
    context?: UserContext;
    pollingInterval?: number;
    skip?: boolean;
}
export function useGetNotifications({
    userId,
    context,
    pollingInterval,
    skip = false
}: UseNotificationsArgs) {

    const [isTabVisible, setIsTabVisible] = useState(!document.hidden);

    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsTabVisible(!document.hidden);
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, []);

    const {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        refetch,
        isSuccess
    } = useGetUserNotificationsQuery(
        { userId: userId! },
        {
            skip: skip || !userId,
            pollingInterval: isTabVisible ? pollingInterval : 0,
            refetchOnFocus: true,

        }
    );

    const notifications = useMemo<NotificationDetail[]>(() => {
        const allNotifications = data || [];

        if (context) {
            return allNotifications.filter(
                n => n.relatedEntity?.metadata?.userContext === context
            );
        }

        return allNotifications;
    }, [data, context]);

    const unreadCount = useMemo(
        () => notifications.filter((n: any) => !n.isRead).length,
        [notifications]
    );

    const archivedCount = useMemo(
        () => notifications.filter((n: any) => n.status === 'archived').length,
        [notifications]
    );

    const activeNotifications = useMemo(
        () => notifications.filter((n: any) => n.status !== 'archived'),
        [notifications]
    );

    const archivedNotifications = useMemo(
        () => notifications.filter((n: any) => n.status === 'archived'),
        [notifications]
    );


    return {
        notifications,
        activeNotifications,
        archivedNotifications,
        unreadCount,
        archivedCount,
        isLoading,
        isFetching,
        isError,
        isSuccess,
        error,
        refetch,
        hasNotifications: notifications.length > 0,
        hasUnread: unreadCount > 0,
    } as const;
}
